export const hasRateLimitPeriodExpired = (history, type, email) => {
    if (!history || !history.length) return { hasExpired: true };
    const historyWithType = history.filter(x => x.type === type && x.status !== 'ABANDONED' && (email ? x.email === email : true));
    if (!historyWithType.length) return { hasExpired: true }; // only rate limit based on type, so you can get both budget and pensionsinfo without limit
    const periodInDays = 30;
    const cutOffDate = new Date(new Date().getTime() - (periodInDays * 24 * 60 * 60 * 1000));
    const hasExpired = historyWithType.every(f => new Date(f.createdAt) < cutOffDate);
    let reason;
    if (!hasExpired) {
        reason = historyWithType.find(f => new Date(f.createdAt) >= cutOffDate);
    }
    return { hasExpired, reason };
};

export function rateLimitPeriodExpiresInDays(history, type) {
    if (!history || !history.length) return 0;
    const historyWithType = history.filter(x => x.type === type );
    if (!historyWithType.length) return 0; // only rate limit files coming from Uniify
    const now = new Date();
    const periodInDays = 30;
    const daysInSeconds = 24 * 60 * 60 * 1000;
    const thirtyDaysAgo = new Date(now.getTime() - (periodInDays * daysInSeconds));
    const newestCreatedAt = historyWithType.reduce((newest, file) => {
        const createdAt = new Date(file.createdAt);
        return (createdAt > newest) ? createdAt : newest;
    }, thirtyDaysAgo);
    const daysUntilExpiration = Math.ceil((newestCreatedAt - thirtyDaysAgo) / (daysInSeconds));
    return daysUntilExpiration;
}
